import disabled from '../../../input/border-color/disabled';

export default disabled;
